import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import { getCurrentStudyProgram } from '../../../utils/getCurrentStudyProgram';

class JumpBack extends React.Component {
  render() {
    let link = {
      to: '',
    };
    const ls = this.props.dashboardHeaderInfo
      ? this.props.dashboardHeaderInfo.lastStudyItem
      : null;
    const user = this.props.user;
    if (ls && user?.studyPrograms?.length > 0) {
      link = {
        id: ls.chapterId,
        pathname: `/app/question/${getCurrentStudyProgram(user, this.props.pfeSktId).id}/${ls.chapterId}?isChapterId`,
        studyProgramId: getCurrentStudyProgram(user, this.props.pfeSktId).id,
      };
    }

    return (
      <div className="dashboard-jumpback-header">
        <div className="top-line" />
        {!this.props.dashboardHeaderInfoWaiting &&
          !this.props.pfeSktIdWaiting &&
          this.props.dashboardHeaderInfo?.lastStudyItem && (
            <Row className="d-flex m-0">
              <Col xs={0} xl={2} className="d-flex p-0">
                <h4 className="d-none d-xl-block my-auto">
                  {this.props.dashboardHeaderInfo.lastStudyItem.alreadyStudy
                    ? 'Jump back in.'
                    : 'Quick start.'}
                </h4>
              </Col>
              <Col xs={0} sm={7} xl={7} className="d-flex p-0">
                <p className="d-none d-sm-block my-auto">
                  {`${this.props.dashboardHeaderInfo.lastStudyItem.referenceName} ${this.props.dashboardHeaderInfo.lastStudyItem.chapterName}`}
                </p>
              </Col>
              <Col xs={12} sm={5} xl={3} className="text-center d-flex p-0">
                <Link
                  to={link.pathname}
                  className="btn m-auto btn-call-to-action p-0"
                >
                  <button className="btn btn-call-to-action text-center m-auto">
                    {this.props.dashboardHeaderInfo.lastStudyItem.alreadyStudy
                      ? 'CONTINUE STUDYING'
                      : 'START STUDYING'}
                  </button>
                </Link>
              </Col>
            </Row>
          )}
      </div>
    );
  }
}

JumpBack.propTypes = {
  chaper: PropTypes.string,
  firstTime: PropTypes.bool,
};
export default JumpBack;
